var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.0265V10.1921C18.5 8.1164 16.784 6.5 14.75 6.5H9.27075C10.1089 3.90133 12.7972 2 15.984 2C19.8411 2 22.968 4.78534 22.968 8.22123C22.968 9.78607 22.3194 11.216 21.2486 12.3092C21.3644 13.4608 21.8643 14.0928 22.9297 14.7313C23.0647 14.8122 22.9899 15.0262 22.8348 14.9973C21.0302 14.6612 20.1183 14.1938 19.5518 13.5706C19.2181 13.7475 18.8665 13.9004 18.5 14.0265Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.1921C2 8.98144 3.00736 8 4.25 8H14.75C15.9926 8 17 8.98144 17 10.1921V17.5789C17 18.7896 15.9926 19.7711 14.75 19.7711H5L3.33565 21.7243C2.89277 22.2637 2 21.9586 2 21.2679V10.1921ZM6.5 14C6.5 13.4477 6.05228 13 5.5 13C4.94772 13 4.5 13.4477 4.5 14C4.5 14.5523 4.94772 15 5.5 15C6.05228 15 6.5 14.5523 6.5 14ZM10.5 14C10.5 13.4477 10.0523 13 9.5 13C8.94772 13 8.5 13.4477 8.5 14C8.5 14.5523 8.94772 15 9.5 15C10.0523 15 10.5 14.5523 10.5 14ZM13.5 15C14.0523 15 14.5 14.5523 14.5 14C14.5 13.4477 14.0523 13 13.5 13C12.9477 13 12.5 13.4477 12.5 14C12.5 14.5523 12.9477 15 13.5 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble36);
export default __webpack_public_path__ + "static/media/speech-bubble-36.12b221244a0b9e401c0d607d246ff905.svg";
export { ForwardRef as ReactComponent };